import { Component } from '@angular/core';

@Component({
    selector: 'app-email-verification-complete-vector',
    templateUrl: './email-verification-complete-vector.component.html',
    styleUrls: ['./email-verification-complete-vector.component.scss'],
    standalone: false
})
export class EmailVerificationCompleteVectorComponent {

}
